import type { FC, PropsWithChildren } from "react";
import classes from "../../styles/NewTable.module.css";

type TableProps = PropsWithChildren<{
  style?: React.CSSProperties;
  className?: string;
}>;

const Table: FC<TableProps> = (props) => {
  const containerStyle = {
    // fontFamily: 'Roboto, sans-serif',
    // fontFamily: 'Inter, sans-serif',
    ...(props.style || {}),
  };

  return (
    <div
      style={containerStyle}
      className={`${classes.tableContainer} ${props.className}`}
    >
      <table className={`${classes.table} ${props.className}`}>
        {props.children}
      </table>{" "}
    </div>
  );
};

export default Table;
